import type { JSModuleWithDefaultExport } from '../../types';

export function isJSModuleWithDefaultExport<T>(
	module: T | JSModuleWithDefaultExport<T>,
): module is JSModuleWithDefaultExport<T> {
	try {
		// This should be replaced with Object.hasOwn once it is more widely supported
		return Object.prototype.hasOwnProperty.call(module as JSModuleWithDefaultExport<T>, 'default');
	} catch (_) {
		// This fallback will occur when module is undefined, or null after converting to Object.hasOwn
		return false;
	}
}
